import React from 'react';

import { Layout } from '../../components/Layout/Layout';
import { Props as FooterProps } from '../../containers/FooterContainer/FooterContainer';
import { messageHooks } from '../../hooks/messageHooks/messageHooks';
import { AppDataStoreData, GlobalMessages } from '../../types/Messages';
import { Props as HeaderProps } from '../HeaderContainer/HeaderContainer';

export const hooks = {
  useLayoutLoading(
    withFooter: boolean,
    withFooterTopAndMiddleParts: boolean,
  ) {
    const pageEntityLoading = messageHooks.useSubjectState(GlobalMessages.PageEntityLoading);
    const pageContentLoading = messageHooks.useSubjectState(GlobalMessages.PageContentLoading);

    const footerMiddlePartLoading = messageHooks.useSubjectState(AppDataStoreData.Loading);

    return React.useMemo(() => {
      const pageLoading = pageEntityLoading || pageContentLoading;

      return withFooter && withFooterTopAndMiddleParts
        ? pageLoading || footerMiddlePartLoading
        : pageLoading;
    }, [
      footerMiddlePartLoading,
      pageContentLoading,
      pageEntityLoading,
      withFooter,
      withFooterTopAndMiddleParts,
    ]);
  },
};

export type Props = {
  children: JSX.Element;

  contentClassName?: string;
  contentInnerClassName?: string;
  footerProps?: FooterProps;
  headerProps?: HeaderProps;
  loadingWrapperClassName?: string;

  stretchInnerContentWithFooterBottomPartToFullScreen?: boolean;
  stretchInnerContentWithoutFooterToFullScreen?: boolean;

  withFooter?: boolean;
  withHeader?: boolean;
};

export const LayoutContainer = React.memo((props: Props) => {
  const withFooter = props.withFooter !== false;
  const withFooterTopAndMiddleParts = props.footerProps?.showTopAndMiddleParts !== false;

  const loading = hooks.useLayoutLoading(withFooter, withFooterTopAndMiddleParts);

  return (
    <Layout
      {...props}
      loading={loading}
    />
  );
});

LayoutContainer.displayName = 'LayoutContainer';
